import BgTenantDetails from "./bg-tanant-details.png";

const images = {
  BgTenantDetails,
};

export default images;
